const DEAL_REDUX_STATE_KEY_PREFIX = 'reduxState-deal-';

const randomFallback = () =>
  `${Math.random().toString(36).slice(2, 10)}${Math.random()
    .toString(36)
    .slice(2, 10)}`;

export const createDealStateId = (): string => {
  const createdAt = Date.now().toString(36);
  try {
    if (typeof window !== 'undefined' && window.crypto?.randomUUID) {
      return `${createdAt}_${window.crypto.randomUUID()}`;
    }
  } catch {
    // ignore and fallback
  }

  return `${createdAt}_${randomFallback()}`;
};

export const getDealReduxStateStorageKey = (stateId: string) =>
  `${DEAL_REDUX_STATE_KEY_PREFIX}${stateId}`;

const listDealReduxStateStorageKeys = () => {
  const keys: string[] = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (!key) continue;
    if (!key.startsWith(DEAL_REDUX_STATE_KEY_PREFIX)) continue;
    keys.push(key);
  }
  return keys;
};

const getCreatedAtForStorageKey = (storageKey: string) => {
  const stateId = storageKey.slice(DEAL_REDUX_STATE_KEY_PREFIX.length);
  const underscoreIndex = stateId.indexOf('_');
  if (underscoreIndex <= 0) return null;
  const tsBase36 = stateId.slice(0, underscoreIndex);
  const ts = parseInt(tsBase36, 36);
  return Number.isFinite(ts) ? ts : null;
};

const tryStoreJson = (storageKey: string, value: string) => {
  try {
    localStorage.setItem(storageKey, value);
    return true;
  } catch {
    return false;
  }
};

export const storeDealReduxStateForNewTab = (state: unknown) => {
  const stateId = createDealStateId();
  const storageKey = getDealReduxStateStorageKey(stateId);
  const value = JSON.stringify(state);

  if (!tryStoreJson(storageKey, value)) {
    // If storage is full, clear out older deal transfer keys and retry.
    const existingKeys = listDealReduxStateStorageKeys()
      .filter((key) => key !== storageKey)
      .sort((a, b) => {
        const ta = getCreatedAtForStorageKey(a) ?? 0;
        const tb = getCreatedAtForStorageKey(b) ?? 0;
        return ta - tb;
      });

    for (const key of existingKeys) {
      try {
        localStorage.removeItem(key);
      } catch {
        // ignore
      }

      if (tryStoreJson(storageKey, value)) break;
    }
  }

  return { stateId, storageKey };
};
